export const DYNAMICS_CONNECT_MODAL_TITLE = "si.management.dynamics.connect_modal.title";
export const DYNAMICS_CONNECT_MODAL_INSTANCE_URL_LABEL =
    "si.management.dynamics.connect_modal.instance_url.label";
export const DYNAMICS_CONNECT_MODAL_INSTANCE_URL_PLACEHOLDER =
    "si.management.dynamics.connect_modal.instance_url.placeholder";
export const DYNAMICS_CONNECT_MODAL_INSTANCE_URL_HINT =
    "si.management.dynamics.connect_modal.instance_url.hint";
export const DYNAMICS_CONNECT_MODAL_INSTANCE_URL_ERROR =
    "si.management.dynamics.connect_modal.instance_url.error";
export const DYNAMICS_CONNECT_MODAL_TERMS_TITLE =
    "si.management.dynamics.connect_modal.terms.title";
export const DYNAMICS_CONNECT_MODAL_TERMS_TEXT = "si.management.dynamics.connect_modal.terms.text";
export const DYNAMICS_CONNECT_MODAL_ACCEPT_BUTTON =
    "si.management.dynamics.connect_modal.button.accept";
export const DYNAMICS_CONNECT_MODAL_CANCEL_BUTTON =
    "si.management.dynamics.connect_modal.button.cancel";
